import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { ArtworkPayload } from "./artworks.types";
import { createArtworkApi, deleteArtworkApi, getArtworksApi } from "./artworks.api";

interface ArtworksState {
  isLoading: boolean;
  error: string | null;
  artworks: any;
}
const initialState: ArtworksState = {
  isLoading: false,
  error: null,
  artworks: []
}

export const createArtwork = createAsyncThunk(
  "artworks/createArtwork",
  async(artwork: ArtworkPayload, {rejectWithValue}) => {
    try {
      const response = await createArtworkApi(artwork)
      return response
    } catch(error: any) {
      return rejectWithValue(error.response?.data || error.message)
    }
  }
)
export const getArtworks = createAsyncThunk(
  "artworks/getArtworks",
  async(_, {rejectWithValue}) => {
    try {
      const response = await getArtworksApi()
      return response
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message)
    }
  }
)
export const deleteArtwork = createAsyncThunk(
  "artworks/deleteArtwork",
  async(artworkId: string, {rejectWithValue}) => {
    try {
      const success = await deleteArtworkApi(artworkId);
      if(success) {
        return artworkId;
      }
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
)
const artworkSlice = createSlice({
  name: 'artworks',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createArtwork.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createArtwork.fulfilled, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.artworks.push(action.payload)
      })
      .addCase(createArtwork.rejected, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.error = action.payload
      })
      .addCase(getArtworks.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(getArtworks.fulfilled, (state, action: PayloadAction<any>) => {
        state.isLoading = false
        state.artworks = action.payload
      })
      .addCase(getArtworks.rejected, (state, action: PayloadAction<any>) => {
        state.isLoading = false
        state.error = action.payload
      })
      .addCase(deleteArtwork.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteArtwork.fulfilled, (state, action) => {
        state.isLoading = false;
        state.artworks = state.artworks.filter((item) => item.id !== action.payload)
      })
      .addCase(deleteArtwork.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
  }

})

export const { clearError } = artworkSlice.actions;
export default artworkSlice.reducer;